import styled from 'styled-components'
import { ContainerProps } from './Container.types'
import { StyledBox } from '../Box/Box.styles'

const MAX_WIDTHS = {
  xs: '444px',
  sm: '600px',
  md: '960px',
  lg: '1280px',
  xl: '1920px',
}

const getMaxWidth = (
  maxWidth: ContainerProps['maxWidth']
): string | undefined => {
  if (maxWidth === false) return undefined
  if (typeof maxWidth === 'string' && maxWidth in MAX_WIDTHS) {
    return MAX_WIDTHS[maxWidth as keyof typeof MAX_WIDTHS]
  }
  if (typeof maxWidth === 'number') return `${maxWidth}px`
  if (typeof maxWidth === 'string') return maxWidth
  return MAX_WIDTHS.lg
}

export const StyledContainer = styled(StyledBox)<{
  $maxWidth?: ContainerProps['maxWidth']
  $fixed?: boolean
  $disableGutters?: boolean
}>`
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  ${({ $maxWidth = 'lg' }) => {
    const width = getMaxWidth($maxWidth)
    return width && `max-width: ${width};`
  }}

  ${({ $disableGutters }) =>
    !$disableGutters &&
    `
    padding-left: 16px;
    padding-right: 16px;

    @media (min-width: 600px) {
      padding-left: 24px;
      padding-right: 24px;
    }
  `}

  ${({ $fixed }) =>
    $fixed &&
    `
    @media (min-width: 0px) {
      max-width: ${MAX_WIDTHS.xs};
    }
    @media (min-width: 600px) {
      max-width: ${MAX_WIDTHS.sm};
    }
    @media (min-width: 960px) {
      max-width: ${MAX_WIDTHS.md};
    }
    @media (min-width: 1280px) {
      max-width: ${MAX_WIDTHS.lg};
    }
    @media (min-width: 1920px) {
      max-width: ${MAX_WIDTHS.xl};
    }
  `}
`
